import { IconProps } from "../../utils/global-types/global-types";

const PlayIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M8.014 3.773C6.681 2.989 5 3.95 5 5.497v13.006c0 1.547 1.68 2.508 3.014 1.724l11.056-6.503c1.314-.774 1.314-2.675 0-3.448z"
      ></path>
    </svg>
  );
};

export default PlayIcon;
